import { NextPrevGalleryIcon } from '../buttons/IconButtons'
import CustomHorizontalInfiniteScrollApp from "./CustomHorizontalInfiniteScrollApp";

/**
 * @file CustomHorizontalInfiniteScroll.jsx
 * @description A horizontally scrollable component that supports infinite scroll with navigation arrows and gradient overlays.
 *
 * @author Jhovanny Fragoso Marquez
 * @jobTitle Frontend Developer
 * @email jfragoso@ibl.mx
 *
 * @component
 * @param {Object} props - Component props.
 * @param {Array<any>} props.items - **Required.** Items to render horizontally.
 * @param {(item: any, index: number) => React.ReactNode} props.renderItem - **Required.** Render function for each item.
 * @param {number} [props.scrollStep=450] - **Optional.** Pixels to scroll when clicking arrows.
 * @param {string} [props.className=""] - **Optional.** Extra class names for the scroll container (applied to the wrapper div with scrollbar).
 * @param {string} [props.classItem=""] - **Optional.** Extra class names applied to each individual item wrapper.
 * @returns {JSX.Element} Horizontally scrollable list with controls.
 *
 * @example
 * import CustomHorizontalInfiniteScroll from "./CustomHorizontalInfiniteScroll";
 *
 * const items = [
 *   { id: 1, label: "Item 1" },
 *   { id: 2, label: "Item 2" },
 *   { id: 3, label: "Item 3" },
 * ];
 *
 * function Example() {
 *   return (
 *     <CustomHorizontalInfiniteScroll
 *       items={items}
 *       renderItem={(item) => <div>{item.label}</div>}
 *       scrollStep={300}
 *     />
 *   );
 * }
 */

const CustomHorizontalInfiniteScroll = ({ items = [], renderItem, scrollStep = 450, className="", classItem="" }) => {
    const {
        containerRef,
        isAtStart,
        canScroll,
        scrollLeft,
        scrollRight
    } = CustomHorizontalInfiniteScrollApp(scrollStep);

    return (
        <div className="d-flex align-items-center pb-1 position-relative">
            {canScroll && (
                <div className={isAtStart ? "is-first-position" : "is-not-first-position"} />
            )}

            {canScroll && !isAtStart && (
                <button id='btn_shis_left' className="scroll-btn left" onClick={scrollLeft}>
                    <NextPrevGalleryIcon />
                </button>
            )}

            <div className={`horizontal-scroll-container custom-scrollbar ${className}`} ref={containerRef}>
                {items.map((item, idx) => (
                    <div key={idx} className={classItem}>{ renderItem(item, idx) }</div>
                ))}
            </div>

            {canScroll && (
                <button id='btn_shis_right' className="scroll-btn right" onClick={scrollRight}>
                    <NextPrevGalleryIcon />
                </button>
            )}
        </div>
    );
};

export default CustomHorizontalInfiniteScroll;
